import Swal from "sweetalert2";
import { authHeader } from './authHeader';

var url_json = require("../location.json");

if (window.location.origin.includes("localhost")) {
    url_json = url_json.local;
} else {
    url_json = url_json.production;
}

const Pdfs = {
    obtenerPdfCampo: async campo => {
        let url = url_json + "/pdf/campo"
        let body = {
            campo
        };

        let request = {
            method: 'POST',
            body: JSON.stringify(body),
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let json = await response.json();
        return { success: response.ok, data: json.data, code: json.message };
    },
    agregarPdf: async body => {
        let url = url_json + "/pdf"

        let request = {
            method: 'POST',
            body: JSON.stringify(body),
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let json = await response.json();
        return { success: response.ok, data: json.data, code: json.message };
    },
    eliminarPdf: async id => {
        return Swal.fire({
            icon: "question",
            title: '¿Esta seguro que desea eliminar el PDF?',
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: 'Si',
            denyButtonText: `No`,
        }).then(async (result) => {
            if (result.isConfirmed) {
                let url = url_json + "/pdf/delete/" + id;
                let request = {
                    method: 'PATCH',
                    headers: authHeader()
                }

                let response = await fetch(url, request);
                let res = await response.json();
                if (response.ok) {
                    Swal.fire(
                        'Eliminación exitosa!',
                        'PDF eliminado correctamente' ,
                        'success'
                    )
                } else {
                    Swal.fire(
                        'Error!',
                        'No se pudo eliminar el PDF' ,
                        'error'
                    )
                }
                return { success: response.ok, data: res.data };
            } else if (result.isDenied) {
                Swal.fire(
                    'Eliminación cancelada',
                    'El campo quedo intacto' ,
                    'succes'
                )
            }
        })
    }
}

export default Pdfs;
